<div class="container-fluid pt-3">
	<jhi-collapsible heading="{{translateService.instant('lists.title')}}">
		<div class="container-fluid">
			<div class="table-responsive custom-scroll-style" style="max-height: 400px; overflow-y: auto; overflow-x: auto;">
				<table class="table table-striped table-bordered table-curved" *ngIf="germplasmLists.length else nodata">
					<thead class="sticky-header">
					<tr>
						<th scope="col" jhiTranslate="lists.name">Name</th>
						<th scope="col" jhiTranslate="lists.date">Date</th>
						<th scope="col" jhiTranslate="lists.description">Description</th>
						<th scope="col" jhiTranslate="lists.locked">Locked</th>
					</tr>
					</thead>
					<tbody>
					<tr *ngFor="let germplasmList of germplasmLists">
                        <td><a *ngIf="germplasmDetailsContext.isModal && isClickable(germplasmList)" [href]="getSafeUrl(germplasmList.listId, germplasmList.listName)" (click)="closeDialog()"><truncate-span [textInput]="germplasmList.listName" [maxLength]="30"></truncate-span></a>
                            <span *ngIf="germplasmDetailsContext.isModal && !isClickable(germplasmList)" class="btn btn-link disabled p-0"><truncate-span [textInput]="germplasmList.listName"></truncate-span></span>
							<span *ngIf="!germplasmDetailsContext.isModal"><truncate-span [textInput]="germplasmList.listName"></truncate-span></span>
						</td>
						<td>{{germplasmList.creationDate}}</td>
                        <td><truncate-span [textInput]="germplasmList.description" [maxLength]="30"></truncate-span></td>
						<td>
							<i [ngClass]="germplasmList.locked ? 'fa fa-lock': 'fa fa-unlock'" aria-hidden="true"></i>
						</td>
					</tr>
					</tbody>
				</table>
				<ng-template #nodata>
					<table class="table table-striped table-bordered table-curved">
						<thead>
						<tr>
							<th></th>
						</tr>
						</thead>
						<tbody>
						<tr>
							<td jhiTranslate="no.data"></td>
						</tr>
						</tbody>
					</table>
				</ng-template>
			</div>
		</div>
	</jhi-collapsible>
</div>
